import React from 'react'

import VCCustomAOSWrapper from './components/VCCustomAOSWrapper'
import VCCustomCompanyAuthorities from './components/VCCustomCompanyAuthorities'
import VCCustomContact from './components/VCCustomContact'
import VCCustomContactCTA from './components/VCCustomContactCTA'
import VCCustomContactForm from './containers/VCCustomContactForm'
import VCCustomGoogleMaps from './components/VCCustomGoogleMaps'
import VCCustomGPWChart from './containers/VCCustomGPWChart'
import VCCustomEvents from './components/VCCustomEvents'
import VCCustomHelpline from './components/VCCustomHelpline'
import VCCustomLatestMarketReport from './components/VCCustomLatestMarketReport'
import VCCustomLatestReport from './components/VCCustomLatestReport'
import VCCustomLatestOffers from './components/VCCustomLatestOffers'
import VCCustomRow from './components/VCCustomRow'
import VCCustomSpokesperson from './components/VCCustomSpokesperson'
import VCCustomWSGroupMap from './components/VCCustomWSGroupMap'
import VCGitemCustomPostDate from './components/VCGitemCustomPostDate'
import VCRow from '../components/VCRow'

const path = window.location.href;

const regex = /(<([^>]+)>)/ig;
const changingLang = (el, str) => {
  if (str == 1) {
    if (window.location.pathname.indexOf('pl') > 0) {
        return 'akcje'
    }
    return "shares"
  }
  if (str == 2) {
    if (window.location.pathname.indexOf('pl') > 0) {
        return 'zł'
    }
    return "PLN"
  }
  if (el) {
    if (window.location.pathname.indexOf('pl') > 0) {
      return 'Kapitał zakładowy Emitenta'
    }
    return "The Issuer's share capital"
  }
  if (window.location.pathname.indexOf('pl') > 0) {
    return 'Dzieli się na'
  }
  return "Is divided into"
}

const elements = [
  {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_aos_wrapper',
    render: props => <VCCustomAOSWrapper children={props.children} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_company_authorities',
    render: props => <VCCustomCompanyAuthorities hrefManagement={props.element.attribs['data-vc-link-first']} hrefSupervisory={props.element.attribs['data-vc-link-second']} />
  },{
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_google_maps',
    render: props => <VCCustomGoogleMaps />
  },{
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_gpw_chart',
    render: props => <VCCustomGPWChart />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_contact',
    render: props => <VCCustomContact title={props.element.attribs['data-vc-title']} icon={props.element.attribs['data-vc-icon']} name={props.element.attribs['data-vc-name']} phone={props.element.attribs['data-vc-phone']} email={props.element.attribs['data-vc-email']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_contact_cta',
    render: props => <VCCustomContactCTA href={props.element.attribs['data-vc-link']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_contact_form',
    render: props => <VCCustomContactForm />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_events',
    render: props => <VCCustomEvents day={props.element.attribs['data-vc-day']} month={props.element.attribs['data-vc-month']} year={props.element.attribs['data-vc-year']} body={props.element.attribs['data-vc-body']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_helpline',
    render: props => <VCCustomHelpline phone={props.element.attribs['data-vc-phone']} hours={props.element.attribs['data-vc-hours']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_latest_market_report',
    render: props => <VCCustomLatestMarketReport hrefDownload={props.element.attribs['data-vc-link-first']} hrefMore={props.element.attribs['data-vc-link-second']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_latest_report',
    render: props => <VCCustomLatestReport href={props.element.attribs['data-vc-link']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_latest_offers',
    render: props => <VCCustomLatestOffers href={props.element.attribs['data-vc-link']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_shareholders',
    render: props => (
      <div className="shares-box">
        <h4>{ changingLang('1') }</h4>
        <div className="value">{props.element.attribs['data-vc-value-first']} { changingLang('1', 2) }</div>
        <h4>{ changingLang() }</h4>
        <div className="value">{props.element.attribs['data-vc-value-second']} { changingLang('1', 1) }</div>
      </div>
    )
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_gitem_custom_post_date',
    render: props => <VCGitemCustomPostDate className={props.element.attribs['data-vc-class']} date={new Date(props.post.getDate())} />
  }, {
    // override vc_row
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && (props.element.attribs['data-vc-tag'] === 'vc_row' || props.element.attribs['data-vc-tag'] === 'vc_row_inner'),
    render: props => props.element.attribs['data-vc-parallax'] ? <VCCustomRow className={props.element.attribs['data-vc-class']} children={props.children} /> : <VCRow className={props.element.attribs['data-vc-class']} children={props.children} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_spokesperson',
    render: props => <VCCustomSpokesperson name={props.element.attribs['data-vc-name']} phone={props.element.attribs['data-vc-phone']} email={props.element.attribs['data-vc-email']} />
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_wsgroup_countries',
    render: props => (
      <ul className="wsgroup-countries">
        {props.element.attribs['data-vc-csv'].replace(/\r\n/g, '\n').split('\n').map((item, key) => (
          <li key={key} className={"wsgroup-countries--" + item.split(',')[0].trim()}>
            <span>{item.split(',')[2].trim().replace(regex, '')}</span> {item.split(',')[1].trim().replace(regex, '')}
          </li>
        ))}
      </ul>
    )
  }, {
    match: props => props.element.name === 'section' && props.element.attribs !== undefined && props.element.attribs['data-vc-tag'] === 'vc_custom_wsgroup_map',
    render: props => <VCCustomWSGroupMap csv={props.element.attribs['data-vc-csv']} title={props.element.attribs['data-vc-title']} />
  }
]

export default elements


// WEBPACK FOOTER //
// ./src/custom/elements.js